import { inject, Injectable } from '@angular/core';
import { DiplomaCert } from '@app/core/models';
import { ViewService } from '@makiwin/ngx-drupal8-rest';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DiplomaService {
  private readonly viewService = inject(ViewService);

  /**
   * Fetches the diploma certificate for a given category TID.
   *
   * @param categoryTid - The unique identifier of the diploma category.
   * @returns An Observable that emits the first `DiplomaCert` found for the specified category,
   *          or `undefined` if none is found.
   */
  fetch(categoryTid: number): Observable<DiplomaCert | undefined> {
    return this.viewService
      .get('/api/v1/my-diploma.json', { args: [categoryTid] })
      .pipe(map((data: DiplomaCert[]) => data[0]));
  }

  /**
   * Retrieves the expiration date of the user's active license.
   *
   * @returns An Observable that emits the expiration date as a string, or `undefined` if not available.
   */
  getExpireDate(): Observable<string | undefined> {
    return this.viewService
      .get('/api/v1/api_my_active_license.json')
      .pipe(map((data: { id: number; expires: string }[]) => data[0]?.expires));
  }
}
